import { Modal} from 'react-bootstrap';

const DataSelectionModal = ({ show, onHide, dataType, child }) => { 
    return (
        <Modal show={show} onHide={onHide} backdrop={true} dialogClassName="modal-90w modal-content-1" backdropClassName="modal-backdrop-1" centered>
            <Modal.Header closeButton>
                <Modal.Title>Select {dataType}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ padding: 10 }}>
                    {child}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DataSelectionModal;